module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Suset#1-8c5f785f6821a630d944cc028b8b26f7.svg";